import React, {useEffect, useState} from 'react';
import {Modal, View} from 'react-native';
import {Spinner} from './index';
import MaintenanceNavigator from './MaintenanceNavigator';
import endpoints from '../../services/rest/endpoints';
import {startAvailabilityPolling} from '../../services/availabilityPolling';

export default function AvailabilityGate({children}) {
  const [status, setStatus] = useState(null);
  const [checkingStartup, setCheckingStartup] = useState(true);

  useEffect(() => startAvailabilityPolling({
    endpoint: endpoints.checkVersion,
    onStatus: setStatus,
    onCheckComplete: () => setCheckingStartup(false),
  }), []);

  const maintenance = status?.inMaintenanceMode === true;
  const blocked = checkingStartup || maintenance;
  return (
    <View style={{flex: 1}}>
      {/* Keep navigation, login state and unfinished forms mounted for recovery. */}
      <View style={{flex: 1, display: blocked ? 'none' : 'flex'}}>
        {children}
      </View>
      {checkingStartup ? <Spinner /> : maintenance ? (
        <Modal visible animationType="none">
          <MaintenanceNavigator infoText={status.infoText} infoURL={status.infoURL} />
        </Modal>
      ) : null}
    </View>
  );
}
